<template>
  <div class="page-newsletters tier tier-two">
    <div class="builder-tip">Here is a list Mailchimp accounts integrated with your site</div>

    <div class="site-newsletters">
      <PageHeader>
        <div></div>
        <router-link
          :to="{
            name: 'add-newsletter',
            params: {companyId: companyId, siteId: siteId}
          }"
          class="btn is-secondary"
          v-if="!hasNewsletter">
          Connect
        </router-link>
      </PageHeader>

      <ul class="tier-list" v-if="hasNewsletter">
        <li class="tier-list-item">
          <router-link
            :to="{
              name: 'newsletter',
              params: {siteId: siteId}
            }">
            Newsletter (List {{newsletter.mailchimp_list_id}})
          </router-link>
        </li>
      </ul>

      <section class="tier-content" v-else>
        <div class="helper-text">
          <p>Looks like you haven't connected Mailchimp yet!
            <router-link
              :to="{
                name: 'add-newsletter',
                params: {companyId: companyId, siteId: siteId}
              }">
              Connect now
            </router-link>.
          </p>
        </div>
      </section>

      <transition name="column-left">
        <router-view @updatePage="updatePage"/>
      </transition>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'
import confirm from '@/mixins/confirm'

import {readCompanySiteData} from '@/lib/sites'
import {readCompanySiteMailchimpData} from '@/lib/mailchimps'

import PageHeader from '@/components/PageHeader'

export default {
  name: 'newsletter',

  mixins: [page, pagination, confirm],

  props: {
    companyId: {
      type: String,
      required: true
    },

    siteId: {
      type: String,
      required: true
    }
  },

  components: {
    PageHeader
  },

  data() {
    return {
      site: {},
      newsletter: {}
    }
  },

  methods: {
    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })

      readCompanySiteMailchimpData(this.companyId, this.siteId, this.pagination).then(
        ({data, page}) => {
          this.newsletter = data
          this.pageData = page
        }
      )
    },

    updatePage() {
      this.$emit('updatePage')
    }
  },

  computed: {
    title() {
      return this.site.name
    },

    hasNewsletter() {
      return Object.entries(this.newsletter).length > 0
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.site-newsletters
.page-newsletters
  box-shadow: inset -30px 0px 30px 0px rgba(0, 0, 0, 0.05)
</style>
